var autocomplete;

// Create the autocomplete object, restricting the search to geographical location types.
function initAutocomplete(id) {
	autocomplete = new google.maps.places.Autocomplete(
		(document.getElementById(id)),
		{
			types: ['geocode'],
			componentRestrictions: {country: 'nz'}
		}
	);
}

// Bias the autocomplete object to the user's geographical location, as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
	if (location.protocol !== 'https:') return;
	if (!navigator.geolocation) return;

	navigator.geolocation.getCurrentPosition(function(position) {
		var geolocation = {
			lat: position.coords.latitude,
			lng: position.coords.longitude
		};
		var circle = new google.maps.Circle({
			center: geolocation,
			radius: position.coords.accuracy
		});
		autocomplete.setBounds(circle.getBounds());
	});
}

$(document).ready(function() {


	// Initiate the Compaint form address field
	if ($(document).find('#Form_ComplaintSubmissionForm_Address').length > 0){
		var id = 'Form_ComplaintSubmissionForm_Address';
		initAutocomplete(id);
		geolocate();
	}

	// Initiate the Compaint form address field
	if ($(document).find('#Form_Section224CSubmissionForm_AddressOfSubdivision').length > 0){
		var id = 'Form_Section224CSubmissionForm_AddressOfSubdivision';
		initAutocomplete(id);
		geolocate();
	}
});
